import client, { formatApiError } from './client';

/**
 * Password Database API Client
 * Handles all API calls related to recipient password management
 */

export const getRecipientPasswords = async (oid, passwortDatenbankId) => {
  try {
    const response = await client.get(`/api/passwortdatenbank/recipient-password/alle/${oid}/${passwortDatenbankId}`);
    return { success: true, data: response.data.data };
  } catch (error) {
    console.error("getRecipientPasswords error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Laden der Passwörter") };
  }
};

export const createRecipientPassword = async (dto) => {
  try {
    const response = await client.post('/api/passwortdatenbank/recipient-password/erstellen', dto);
    return response.data;
  } catch (error) {
    console.error("createRecipientPassword error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Erstellen des Passworts") };
  }
};

export const updateRecipientPassword = async (dto) => {
  try {
    const response = await client.put('/api/passwortdatenbank/recipient-password/aktualisieren', dto);
    return response.data;
  } catch (error) {
    console.error("updateRecipientPassword error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Aktualisieren des Passworts") };
  }
};

export const deleteRecipientPassword = async (oid, empfaengerPasswortId) => {
  try {
    const response = await client.delete(`/api/passwortdatenbank/recipient-password/loeschen/${oid}/${empfaengerPasswortId}`);
    return response.data;
  } catch (error) {
    console.error("deleteRecipientPassword error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Löschen des Passworts") };
  }
};

export const deletePasswordDatabase = async (dto) => {
  try {
    const response = await client.delete('/api/passwortdatenbank/loeschen', { data: dto });
    return response.data;
  } catch (error) {
    console.error("deletePasswordDatabase error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Löschen der Passwortdatenbank") };
  }
};

export const getActiveUserCount = async (oid, passwortDatenbankId) => {
  try {
    const response = await client.get(`/api/passwortdatenbank/active-user-count/${oid}/${passwortDatenbankId}`);
    return response.data;
  } catch (error) {
    console.error("getActiveUserCount error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Laden der Benutzeranzahl") };
  }
};

export const getActiveDbSummary = async (oid) => {
  try {
    const response = await client.get(`/api/passwortdatenbank/${oid}/active-db-summary`);
    return response.data;
  } catch (error) {
    console.error("getActiveDbSummary error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Laden der Datenbankübersicht") };
  }
};

export const createOwnDatabase = async (dto) => {
  try {
    const response = await client.post('/api/passwortdatenbank/eigene-erstellen', dto);
    return response.data;
  } catch (error) {
    console.error("createOwnDatabase error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Erstellen der Passwortdatenbank") };
  }
};

export const getUsersForRotation = async (oid, passwortDatenbankId) => {
  try {
    const response = await client.get(`/api/passwortdatenbank/${oid}/${passwortDatenbankId}/users-for-rotation`);
    return response.data;
  } catch (error) {
    console.error("getUsersForRotation error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Laden der Benutzerliste") };
  }
};

export const rotateMasterKey = async (dto) => {
  try {
    const response = await client.post('/api/passwortdatenbank/rotate-masterkey', dto);
    return response.data;
  } catch (error) {
    console.error("rotateMasterKey error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Rotieren des MasterKeys") };
  }
};
